import { BootFileParams } from '@niknevis/vue-modules/types'
import { collect } from 'collect.js'

declare module '@/modules/common/core/boot/collect.js' {
  interface Collection<Item> {
    toEntries<K, V>(): Collection<[K, V]>

    fromEntries<T>(): Collection<{ [key: string]: T }>

    toPairs<K, V>(): Collection<{ key: K, value: V }>

    toPairsOf<K,
      V,
      KK extends keyof any,
      VK extends keyof any>(key: KK, value: VK): Collection<Record<KK, K> & Record<VK, V>>

    fromPairs<T>(): Collection<{ [key: string]: T }>

    fromPairsOf<T>(key: string, value: string): Collection<{ [key: string]: T }>

    macro(name: string, fn: (this: Collection<Item>) => any): void;

    filter(): any
  }
}

export default function({ Vue }: BootFileParams) {
  collect().macro('toEntries', function() {
    return this.map((item, index) => [index, item])
  })

  collect().macro('fromEntries', function() {
    return collect(Object.fromEntries(this.toArray()))
  })

  collect().macro('toPairs', function() {
    return this.toPairsOf('key', 'value')
  })

  collect().macro('toPairsOf', function(this: any, key, value) {
    return this.map((item, index) => ({
      [key]: index,
      [value]: item
    }))
  })

  collect().macro('fromPairs', function() {
    return this.fromPairsOf('key', 'value')
  })

  collect().macro('fromPairsOf', function(this: any, key, value) {
    return this.map((item: any) => [
      item[key],
      item[value]
    ]).fromEntries()
  })
}
